module.exports = __webpack_public_path__ + "static/media/goku2.762d518a.gif";